import React from "react";
import "./NewUpdates.css";

function NewUpdates() {
  return (
    <div className="updates_section">
      <div className="new_updates_block">
        <div className="new_updates_subblock">
          <div className="new_updates_dropdown">
            <div className="new_flex">
              <p className="new_flex_text">New :</p>
            </div>
            <select className="custom_dropdown">
              <option value="" className="custom_dropdown_option">
                <p className="custom_dropdown_para">Select an Option</p>
              </option>
              <option value="financial" className="custom_dropdown_option">
                <p className="custom_dropdown_para">Financial Metrics</p>
              </option>
              <option value="growth" className="custom_dropdown_option">
                <p className="custom_dropdown_para">Growth Indicators</p>
              </option>
              <option value="market" className="custom_dropdown_option">
                <p className="custom_dropdown_para">Market Share</p>
              </option>
            </select>
          </div>

          <div className="new_updates">
            <p className="new_updates_text">
              Headline Financial Metrics
              <span className="new_updates_number">6</span>
            </p>
          </div>
          <div className="new_updates">
            <p className="new_updates_text">
              Headline Financial Metrics
              <span className="new_updates_number">6</span>
            </p>
          </div>
          <div className="new_updates">
            <p className="new_updates_text">
              Headline Financial Metrics
              <span className="new_updates_number">6</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewUpdates;
